<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Chủ nhiệm" :link="[{ text: 'Chủ nhiệm', href: '../ownClassTeacher' }]" />
      </div>
      <div class="flex-center">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && role.type !== 'inspector'"
          class="mr-6"
          outlined
          color="success"
          @click="exportExcel"
        >
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn v-if="$auth.policies['add-new-ownClass']" depressed dark color="#0D47A1" @click="addState = !addState">
          <v-icon left>add</v-icon>{{ btnTitle }}
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <OwnClassTeacherFilter @onFilterChanged="refresh" ref="ownClassTeacherFilter"></OwnClassTeacherFilter>
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <OwnClassTeacherDataTable ref="ownClassTeacherDataTable" @editState="edit" />
    </v-card>

    <OwnClassTeacherNewDialog :state="addState" @done="onFilter" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import OwnClassTeacherFilter from '@/modules/teacher/OwnClassTeacherFilter.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import Vuetify from 'vuetify'
import Vue from 'vue'
import utils from '@/plugins/utils'
import OwnClassTeacherNewDialog from '@/modules/teacher/OwnClassTeacherNewDialog'
import OwnClassTeacherDataTable from '@/modules/teacher/OwnClassTeacherDataTable'

Vue.use(Vuetify)

export default {
  components: {
    Breadcrumbs,
    OwnClassTeacherFilter,
    OwnClassTeacherNewDialog,
    OwnClassTeacherDataTable
  },
  data() {
    return {
      editState: false,
      addState: false,
      deleteState: false,
      selectedTeacher: null,
      ownClass: null
    }
  },
  computed: {
    ...mapState('ownClassTeacher', ['classesData', 'classSearchParams']),
    ...mapGetters('auth', ['profile', 'role']),

    btnTitle() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'Thêm'
      } else {
        return 'Thêm phân công'
      }
    }
  },
  methods: {
    ...mapActions('ownClassTeacher', ['updateClass', 'fetchClasses']),
    edit({ headTeacher, ownClass }) {
      this.selectedTeacher = headTeacher
      this.ownClass = ownClass
      this.editState = !this.editState
    },
    refresh(query) {
      this.$refs.ownClassTeacherDataTable.refresh(query)
    },
    onFilter() {
      this.$refs.ownClassTeacherFilter.onFilterChanged()
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let excelHeader = this.$refs.ownClassTeacherDataTable.headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const list = await this.fetchClasses({ ...this.classSearchParams, _limit: -1 })
        const ownClassTeacherData = JSON.parse(JSON.stringify(list))
        const data = ownClassTeacherData.map(item => {
          if (item.headTeachers && item.headTeachers.length) {
            item.headTeachers = item.headTeachers.map(t => t.name).join(', ')
          } else {
            item.headTeachers = 'Chưa có giáo viên chủ nhiệm'
          }
          return item
        })
        utils.exportExcel(data, excelHeader, 'CongTacChuNhiem')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
